import SignUp from './signup';

const signUpAppElement = document.getElementById('js-sign-up-app');

if (signUpAppElement) {
  const googleClientId = document.getElementById('google-client-data').value;
  const githubClientId = document.getElementById('github-client-data').value;
  const authenticityToken = document.getElementById('authenticity-token-data').value;
  const isEmbeddedSignup = document.getElementById('is-embedded-signup').value;
  const previousSignUpError = document.getElementById('previousSignUpError').dataset['signupError'];
  const preFilledEmail = document.getElementById('preFilledEmail').dataset['email'];
  const sessionId = document.getElementById('sessionId').dataset['sessionId'];

  ReactDOM.render(
    <SignUp
      authenticityToken={authenticityToken}
      googleClientId={googleClientId}
      githubClientId={githubClientId}
      previousSignUpError={previousSignUpError}
      isEmbeddedSignup={isEmbeddedSignup}
      preFilledEmail={preFilledEmail}
      sessionId={sessionId}
    />,
    signUpAppElement);
}
